import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  buttonText: {
    defaultMessage: 'Open {providerName} log in',
    id: 'AwaitingThirdpartyAuthentication.buttonText',
  },
  openProvider: {
    defaultMessage: 'Open {providerName}',
    id: 'AwaitingThirdpartyAuthentication.openProvider',
  },
  openProviderApp: {
    defaultMessage: 'Open {providerAppName} app',
    id: 'AwaitingThirdpartyAuthentication.openProviderApp',
  },
  dontHaveAppInstalled: {
    defaultMessage: "I don't have the app installed",
    id: 'AwaitingThirdpartyAuthentication.secondButtonText',
  },
});
